import { render, staticRenderFns } from "./changeManagerDialog.vue?vue&type=template&id=1c5143b7&scoped=true"
import script from "./changeManagerDialog.vue?vue&type=script&lang=js"
export * from "./changeManagerDialog.vue?vue&type=script&lang=js"
import style0 from "./changeManagerDialog.vue?vue&type=style&index=0&id=1c5143b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5143b7",
  null
  
)

export default component.exports